import { HistoryType } from 'features/trade/components/History/types';

/**
 * @deprecated use the `TransactionHistoryListItem` instead
 * - Part of /history/v3 response
 */
export interface TransactionHistoryDataItem {
  amount: number;
  bank_account_number: string;
  bank_name: string;
  command: string;
  currency: string;
  date: string;
  display_as: string;
  dividend_per_share: number;
  dividend_ratio: string;
  dividend_type: string;
  fee: number;
  is_realized_gain_hidden: boolean;
  label: string;
  lot: number;
  netamount: number;
  price: number;
  realized_amount: number;
  realized_percentage: number;
  shares: number;
  status: string;
  status_color_code: string;
  symbol: string;
  time: string;
  is_day_trade: boolean;
}

/**
 * @deprecated use the `TransactionHistoryResponseBody` instead
 * - Part of /history/v3 response
 */
export type TransactionHistoryResponse = TransactionHistoryDataItem[];

export enum TransactionPeriod {
  All = 'all',
  OneMonth = '1 month',
  ThreeMonths = '3 month',
  OneYear = '1 year',
}

export interface TransactionHistoryParams {
  action?: string;
  keyword?: string;
  period?: TransactionPeriod;
  page?: string;
  limit?: string;
  start?: string; // date format YYYY-MM-DD
  end?: string; // date format YYYY-MM-DD
  /**
   * @deprecated use `keyword` as stock code instead
   * - Part of /history/v3 response
   * - Not being used in the /history
   */
  stockCode?: string;
}

export interface TransactionHistoryMeta {
  max_page: number;
  total_realized_amount: number;
  color_realized_amount: {
    light_mode: string;
    dark_mode: string;
  };
  tooltip_header: string;
  tooltip: string;
  tooltips: [
    {
      header: string;
      description: string;
    },
  ];
}

export interface TransactionHistoryListItem {
  command: HistoryType;
  symbol: string;
  price: number;
  lot: number;
  shares: number;
  amount: number;
  fee: number;
  netamount: number;
  currency: string;
  status: string;
  status_color_code: string;
  realized_amount: number;
  realized_percentage: number;
  realized_color_code: {
    light_mode: string;
    dark_mode: string;
  };
  bank_account_number: string;
  bank_name: string;
  date: string;
  label: string;
  dividend_ratio: string;
  dividend_per_share: number;
  dividend_type: string;
  display_as: string;
  is_realized_gain_hidden: true;
  mutual_fund: string;
  partner_reference: string;
  bonds: {
    product_name: string;
    icon: string;
    stamp_duty: number;
    accrued_interest: number;
    bonds_price: string;
    coupon_tax_percentage: string;
    seller_coupon: number;
    total_realized_amount: number;
    total_realized_amount_percentage: number;
    capital_gain_loss: {
      amount: number;
      amount_nett: number;
      amount_percentage: number;
      amount_nett_percentage: number;
    };
    daily_accrued_interest: number;
    acquisition_price: number;
    accrued_interest_exclude_tax: number;
    accrued_interest_nett: number;
  };
  is_hide_transfer_fee: boolean;
  is_day_trade: boolean;
  time: string;
  move_stock_cash: {
    source: {
      acc_no: string;
      name: string;
    };
    destination: {
      acc_no: string;
      name: string;
    };
  };
}

export interface TransactionHistorySchema {
  date: string;
  monthly_gain: number;
  history_list: TransactionHistoryListItem[];
}

export interface TransactionHistoryResponseBody {
  history: TransactionHistorySchema[];
  meta?: TransactionHistoryMeta;
}
